/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PreRegisterApprovalRequest = {
  properties: {
    professionalId: {
      type: 'string',
      isRequired: true,
    },
    reason: {
      type: 'string',
      isRequired: true,
    },
    document: {
      type: 'File',
    },
  },
} as const;
